import React from 'react'

export interface SmallArrowDownProps {
  size?: number
  color?: string
}

export const SmallArrowDown: React.FC<SmallArrowDownProps> = ({
  size = 16,
  color = '#ffffff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.563 10.143V4.105a.771.771 0 111.542 0v6.038l.84-.908c.496-.535 1.389-.185 1.389.544a.8.8 0 01-.213.543l-2.053 2.219a1 1 0 01-1.468 0l-2.053-2.219a.8.8 0 01-.213-.543c0-.729.893-1.079 1.388-.544l.84.908z"
        fill={color}
      />
    </svg>
  )
}
